import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@rentspree/component-2023.components.atoms.avatar';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

export interface TopNavigationProps {
  activeItem?: 'dashboard' | 'listings' | 'finance' | 'messages';
  onMenuItemClick?: (item: string) => void;
  userAvatarSrc?: string;
  userAvatarAlt?: string;
  className?: string;
}

export const TopNavigation: React.FC<TopNavigationProps> = ({
  activeItem = 'listings',
  onMenuItemClick,
  userAvatarSrc = 'https://mui.com/static/images/avatar/1.jpg',
  userAvatarAlt = 'User Avatar',
  className,
}) => {
  const navigate = useNavigate();

  const menuItems = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'listings', label: 'Listings' },
    { key: 'finance', label: 'Finance' },
    { key: 'messages', label: 'Messages' },
  ];

  const handleMenuClick = (item: string) => {
    onMenuItemClick?.(item);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header
      className={className}
      style={{
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        height: 73,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
      data-testid='top-navigation'
    >
      <div
        style={{
          width: 1280,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingLeft: 24,
          paddingRight: 24,
          position: 'relative',
        }}
      >
        {/* Logo */}
        <div
          style={{
            height: 32,
            width: 'auto',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          data-testid='rentspree-logo'
          onClick={handleLogoClick}
        >
          <img
            src='https://cdn.rentspree.com/static-files/logos/rentspree-logo.svg'
            alt='RentSpree Logo'
            style={{
              height: 32,
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>

        {/* Navigation - Centered */}
        <nav
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: 32,
          }}
          data-testid='navigation'
        >
          {menuItems.map(item => (
            <button
              key={item.key}
              onClick={() => handleMenuClick(item.key)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '8px 0',
                position: 'relative',
              }}
              data-testid={`nav-item-${item.key}`}
            >
              <Typography
                variant='body1'
                style={{
                  color: activeItem === item.key ? '#1f15e1' : '#6b7280',
                  fontWeight: activeItem === item.key ? 500 : 400,
                  fontSize: '16px',
                  borderBottom:
                    activeItem === item.key ? '2px solid #1f15e1' : 'none',
                  paddingBottom: activeItem === item.key ? '6px' : '8px',
                }}
              >
                {item.label}
              </Typography>
            </button>
          ))}
        </nav>

        {/* User Avatar */}
        <Avatar
          src={userAvatarSrc}
          alt={userAvatarAlt}
          size='medium'
          data-testid='user-avatar'
        />
      </div>
    </header>
  );
};
